import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const VehicleDetail = lazyLoader(
  () => import("Containers/Vehicle/VehicleDetail/VehicleDetail")
);

export const VehicleDetailPage = () => {
  return (
    <Layout>
      <VehicleDetail />
    </Layout>
  );
};
